import { differenceInMilliseconds, Duration, intervalToDuration } from 'date-fns';
import isNil from 'lodash/isNil';
import { useEffect, useState } from 'react';

interface DecoradtedDuration extends Duration {
  milliseconds?: number;
}

export const getDuration = (startDate?: number | Date, endDate?: number | Date): DecoradtedDuration => {
  if (isNil(startDate)) {
    return {};
  }

  const milliseconds = differenceInMilliseconds(endDate ?? Date.now(), startDate);
  const duration: DecoradtedDuration = intervalToDuration({
    start: startDate,
    end: endDate ?? Date.now(),
  });

  // if the duration is less than 1 second, add milliseconds property
  if (endDate && milliseconds < 1000) {
    duration.milliseconds = milliseconds;
  }

  return duration;
};

export const useDuration = (startDate?: number | Date, endDate?: number | Date): DecoradtedDuration => {
  const [duration, setDuration] = useState<Duration>(getDuration(startDate, endDate));

  useEffect(() => {
    const updateDuration = () => setDuration(getDuration(startDate, endDate));

    updateDuration();

    let interval: number;
    if (!endDate) {
      interval = window.setInterval(updateDuration, 1000);
    }

    return () => window.clearInterval(interval);
  }, [startDate, endDate]);

  return duration;
};
